{
  "nav": {
    "pricing": "Tarifs",
    "contact": "Contact",
    "menu": "Menu",
    "login": "Connexion",
    "features": "Fonctionnalités",
    "brandHomeAria": "Done-it — accueil",
    "market": {
      "belgium": "Belgique",
      "international": "Monde entier"
    }
  },
  "footer": {
    "tagline": "Done-it — Le suivi du temps, simplifié.",
    "terms": "Conditions",
    "privacy": "Confidentialité",
    "contact": "Contact"
  },
  "help": "Besoin d'aide ?",
  "continue": "Continuer",
  "back": "Retour",
  "change": "Modifier",
  "retry": "Réessayer",
  "errors": {
    "unexpected": "Erreur inattendue"
  },
  "step": {
    "of": "Étape {{n}} sur {{total}}"
  },
  "funnel": {
    "title": "Abonnement · Done-it"
  }
}
